import { UserModel } from './../models/user.model';
import { ZAuthService } from './../services/auth.service';



export const MENU_ITEMS: any[] = [
    {
        title: 'Suppliers barcodes',
        icon: 'fa fa-barcode',
        guard: (zAuthService: ZAuthService, user: UserModel) => zAuthService.isUserAdmin(user) || user.companyId > 0,
        children: [
            {
                title: 'Orders',
                link: '/suppliers-barcodes',
            }]
    },
    {

        title: 'Administration',
        icon: 'fa fa-suitcase',
        guard: (zAuthService: ZAuthService, user: UserModel) => zAuthService.isUserAdmin(user),
        children: [
            {
                title: 'Background jobs',
                link: '/admin/bg-tasks',
            },
            {
                title: 'Localization',
                link: '/admin/localization-settings',
            },
            {
                title: 'System settings',
                link: '/admin/system-settings',
            },
            {
                title: 'General',
                link: '/admin/general',
            },
            {
                title: 'Users',
                link: '/admin/users',
            },
            {
                title: 'User groups',
                link: '/admin/user-groups',
            },
        ]
    },
    /*
    {
        title: 'Tests group',
        icon: 'fa  fa-commenting',
        children: [
            {
                title: 'Bootstrap',
                link: '/bootstrap',
            },
            {
                title: 'Search',
                link: '/search',
            },
            {
                title: 'Actions',
                link: '/actions',
            },
            {
                title: 'Forms',
                link: '/forms',
            },
            {
                title: 'Card',
                link: '/card',
            },
        ]
    } */
]



// WEBPACK FOOTER //
// ./src/app/layout-main/menu.ts